import React from 'react';
import { ChatMessageBubble } from './chat-message-bubble';
import { formatMessageDate, groupMessagesByDate } from '../../utils/chatUtils';

interface Message {
  id: string;
  type: 'user' | 'assistant';
  content: string;
  timestamp: Date;
  isTyping?: boolean;
}

interface MessageListProps {
  messages: Message[];
  userName: string;
  assistantName: string;
}

export const ChatMessageList: React.FC<MessageListProps> = ({
  messages,
  userName,
  assistantName
}) => {
  const groupedMessages = groupMessagesByDate(messages);

  return (
    <div className="flex-1 overflow-y-auto p-4 space-y-4">
      {groupedMessages.map(({ date, messages: dayMessages }) => (
        <div key={date.toDateString()}>
          {/* Date Separator */}
          <div className="flex items-center justify-center my-6">
            <div className="bg-gray-100 dark:bg-gray-800 px-3 py-1 rounded-full text-sm text-gray-600 dark:text-gray-400">
              {formatMessageDate(date)}
            </div>
          </div>

          {/* Messages for this date */}
          {dayMessages.map((msg) => (
            <ChatMessageBubble
              key={msg.id}
              message={msg}
              userName={userName}
              assistantName={assistantName}
            />
          ))}
        </div>
      ))}
    </div>
  );
};
